import type { AiContext } from './types/ai-context';

export const LARGE_PR_INLINE_DIFF_THRESHOLD = 60_000;
export const SIDEBAR_CHAT_REQUEST_TARGET_BYTES = 4_000_000;

export function computeTotalDiffSize(codeContent: AiContext['codeContent']): number {
  return (
    codeContent?.reduce((sum, file) => {
      return sum + (file.patch?.length ?? 0);
    }, 0) ?? 0
  );
}

export function isLargePr(codeContent: AiContext['codeContent']): boolean {
  return computeTotalDiffSize(codeContent) > LARGE_PR_INLINE_DIFF_THRESHOLD;
}

export function getSerializedByteLength(value: unknown): number {
  const serialized = JSON.stringify(value);
  return serialized === undefined ? 0 : new TextEncoder().encode(serialized).byteLength;
}
